<template>
  <div id="container">
    <div class="item-box-content">
      <div class="title-font-style">
        <span>基本信息</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="充值编号：">{{ params.payNumber }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="充值类型：">
              {{"供应商余额充值"}}
              <!-- <span v-show="params.rechargeType ===1">{{ '账户余额'}}</span>
              <span v-show="params.rechargeType ===2">{{ '抵扣金额' }}</span>
              <span v-show="params.rechargeType ===3">{{ '账户余额,抵扣金额' }}</span>-->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="供应商名称：">{{ params.suName }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="申请人：">{{ params.createUser }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属部门：">{{ params.orgName }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请时间：">{{ params.createDate|dateFilter }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="充值至账户余额：">{{ params.amount|priceFilterNum }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="充值至抵扣金额：">{{ params.deductionAmount |priceFilterNum}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="备注：">{{ params.mark }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content" v-if="params.bankCode !== null">
      <div class="title-font-style">
        <span>账户信息</span>
      </div>
      <el-form
        :class="isModify ? '' : 'details-line-height'"
        :label-width="isModify ? '70px' : ''"
        style="padding:20px 30px 0 30px"
      >
        <el-row :gutter="20 ">
          <el-col :span="24"></el-col>
          <el-col :span="12">
            <el-form-item label="账户名称：">
              <span>{{ params.receiptName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:right;" v-if="params.financeState ===4">
            <el-form-item>
              <el-button
                @click="onModify"
                v-if="!isModify&&params.financeState ===4 "
                type="primary"
                plain
              >修改</el-button>
              <el-button
                @click="onSubmit"
                v-if="isModify&&params.financeState ===4 "
                type="primary"
              >提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="银行账户：">
              <span v-show="!isModify">{{ params.receiptBankNumber }}</span>

              <el-select v-show="isModify" v-model="params.receiptBankNumber" @change="changeBank">
                <el-option
                  v-for="(item, index) in contractScreenCondition"
                  :key="index"
                  :label="item.bankCode"
                  :value="item.bankCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开户行：">
              <span>{{ params.receiptOpenBank ||'--'}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="银行行号：">
              <span>{{ params.receiptOpenNumber||'--' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="isModify">
          <el-col :span="8">
            <el-form-item label-width="0">
              <el-button @click="onAddAccount" type="primary" plain>添加账户</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>充值信息</span>
      </div>
      <el-form class="details-line-height" style="margin:20px;" v-show="params.financeState ===5">
        <el-row :gutter="20" class="grayApply">
          <el-col :span="8">
            <el-form-item label="申请充值总额：">
              <span style="color:#D35E5E;">{{params.payAmount|priceFilterNum}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form
        class="details-line-height"
        :class="params.financeState ===4?'paddingBottom':'padding'"
      >
        <div v-if="params.payMenthodDetail === '银行转账'">
          <div
            v-for="(item,index) in params.rechargeBankVos"
            :key="index"
            :class="params.financeState ===4?'deepRed':''"
          >
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="充值方式：">{{ params.payMenthodDetail }}</el-form-item>
              </el-col>
              <el-col :span="8" v-show="params.financeState !==5">
                <el-form-item label="申请充值金额：">
                  <span>{{ params.payAmount |priceFilterNum}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-show="params.financeState ===5">
                <el-form-item label="充值金额：">
                  <span>{{ item.rechargeAmount|priceFilterNum }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-show="params.financeState ===5">
              <el-col :span="8">
                <el-form-item label="充值账户：">{{ item.rechargeName }}</el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-show="params.financeState ===5">
              <el-col :span="8">
                <el-form-item label="备注：">{{ item.rechargeMark }}</el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="充值状态：">
                  <span
                    v-show="params.approvalState ===0||params.financeState ===2||params.financeState ===1||params.financeState ===6"
                    style="color:#e4894b;"
                  >{{ "充值审核" }}</span>
                  <span
                    v-show="params.approvalState ===2||params.financeState ===3"
                    style="color:#D35E5E;"
                  >{{ "审核不通过" }}</span>
                  <span v-show="params.financeState ===4" style="color:#D35E5E;">{{ "退回修改" }}</span>
                  <span v-show="params.financeState ===5" style="color:#e4894b;">{{ "充值成功" }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                v-if="params.financeState ===4||params.approvalState ===2||params.financeState ===3||params.financeState ===5"
              >
                <el-form-item label="处理人：">{{item.processorUser }}</el-form-item>
              </el-col>
              <el-col
                :span="8"
                v-if="params.financeState ===4||params.approvalState ===2||params.financeState ===3 ||params.financeState ===5"
              >
                <el-form-item label="处理时间：">{{ item.processorTime|dateFilter }}</el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              v-show="!(params.approvalState ===0||params.financeState ===1||params.financeState ===5||params.financeState ===6||params.financeState ===5||params.financeState ===2)"
            >
              <el-col :span="15">
                <el-form-item label="备注：">{{item.rechargeMark }}</el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              v-if="params.financeState ===5&&!( item.systemAttachments===null||item.systemAttachments.length===0)"
            >
              <el-col :span="15">
                <el-form-item label-width="0">
                  <span style="margin-top:4px;">付款凭证：</span>
                  <el-button @click="onSee(item.systemAttachments)" type="text">查看</el-button>
                  <el-button
                    @click="onDownload(item.systemAttachments[0].filePath,item.systemAttachments[0].fileName)"
                    type="text"
                  >下载</el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="solid" v-if="!(params.rechargeBankVos.length-1 === index)"></div>
          </div>
        </div>
        <div v-if="params.payMenthodDetail === '承兑汇票'">
          <div
            v-for="(item,index) in params.rechargeFinanceVos"
            :key="index"
            :class="params.financeState ===4?'deepRed':''"
          >
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="充值方式：">{{ params.payMenthodDetail }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="申请充值金额："
                  v-show="params.approvalState ===0||params.financeState ===1||params.financeState ===6"
                >
                  <span>{{ params.payAmount|priceFilterNum }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="票据金额：" v-if="params.financeState ===5">
                  <span>{{ item.billMoney|priceFilterNum }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="params.financeState ===5">
              <el-col :span="8">
                <el-form-item label="票据号码：">{{ item.billNumber }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出票单位：">
                  <span>{{ item.billCompany }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出票行：">
                  <span>{{ item.billBank }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="params.financeState ===5">
              <el-col :span="8">
                <el-form-item label="出票日期：">{{ item.billDate }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="到期日期：">
                  <span>{{ item.billEnddate|dateFilterDate }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="params.financeState ===5">
              <el-col :span="15">
                <el-form-item label="备注：">{{item.mark }}</el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="充值状态：">
                  <span
                    v-show="params.approvalState ===0||params.financeState ===1||params.financeState ===6 || params.financeState ===2"
                    style="color:#e4894b;"
                  >{{ "充值审核" }}</span>
                  <span
                    v-show="params.approvalState ===2||params.financeState ===3"
                    style="color:#D35E5E;"
                  >{{ "审核不通过" }}</span>
                  <span v-show="params.financeState ===4" style="color:#D35E5E;">{{ "退回修改" }}</span>
                  <span v-show="params.financeState ===5" style="color:#e4894b;">{{ "充值成功" }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                v-if="params.financeState ===4||params.approvalState ===2||params.financeState ===3||params.financeState ===5"
              >
                <el-form-item label="处理人：">{{item.processUser }}</el-form-item>
              </el-col>
              <el-col
                :span="8"
                v-if="params.financeState ===4||params.approvalState ===2||params.financeState ===3||params.financeState ===5"
              >
                <el-form-item label="处理时间：">{{ item.processDate|dateFilter }}</el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              v-show="!(params.approvalState ===0||params.financeState ===1||params.financeState ===6 ||params.financeState ===2)"
            >
              <el-col :span="15">
                <el-form-item label="备注：">{{item.rechargeMark }}</el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              v-if="params.financeState ===5 &&!( item.systemAttachments===null||item.systemAttachments.length===0) "
            >
              <el-col :span="15">
                <el-form-item label-width="0">
                  <span style="margin-top:4px;">付款凭证：</span>
                  <el-button @click="onSee(item.systemAttachments)" type="text">查看</el-button>
                  <el-button
                    @click="onDownload(item.systemAttachments[0].filePath,item.systemAttachments[0].fileName)"
                    type="text"
                  >下载</el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="solid" v-if="!(params.rechargeFinanceVos.length-1 === index)"></div>
          </div>
        </div>
      </el-form>
    </div>

    <!-------------- 工单日志 -------------->
    <operation-log-and-flow :flowLabel="flowLabel" :id="id"></operation-log-and-flow>
    <!-------------- 添加账户 -------------->

    <add-bank-account-dialog ref="addBankAccountDialogRefs" @addAccountDialog="addAccountDialog"></add-bank-account-dialog>
    <!-------------- 查看资格证书 -------------->
    <brand-dialog ref="brandDialogRef" :title="`查看凭证`"></brand-dialog>
  </div>
</template>
<script>
import addBankAccountDialog from '@/components/AddAccount/addAccountDialog' // 添加账户
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow' // 工单日志
import BrandDialog from '@/views/crm/components/supplier/dialog/brandDialog'
import { formatDate, uploadDownRecharge } from '@/util/tool'
// downLoadFileBlob
import {
  updateSupplierRecharge
} from '@/api/purchase/purchaseManage'
import { queryRechargeDetailById } from '@/api/supplier/supplierManage'
import { queryBySuId } from '@/api/purchase/purchasePlanList'
// import { download } from '@/api/sell/sellManage'
export default {
  components: {
    BrandDialog,
    'operation-log-and-flow': operationLogAndFlow,
    'add-bank-account-dialog': addBankAccountDialog
  },
  data () {
    return {
      id: '',
      state: ['充值审核', '', '审核不通过', '退回修改', '充值成功'], // 审核状态
      approvalState: ['', '充值审核', '审核不通过', '充值成功'], // 审核状态
      // 1 审核中 2 待处理 3 审核不通过 4 审核不通过(退回修改) 5 充值成功 6 充值失败
      contractScreenCondition: [], // 银行账户
      loadingTable: false,
      list: [], // 相关信息
      accountBalance: [
        // 充值方案数组
        {
          purchasePaymentPlanList: [
            {
              isAccount: '',
              accountTransfer: '',
              state: '',
              processUser: '',
              processDate: '',
              approvalMark: ''
            }
          ]
        }
      ],
      flowLabel: '采购充值流程', // 工单日志
      type: '',
      isModify: false,
      params: {
        // 渲染数据
        purchasePaymentVo: {}
      }
    }
  },
  mounted () {
    this.id = this.$route.query.sraId
    this.getList()
  },
  methods: {
    onDownload (filePath, fileName) { // 下载
      uploadDownRecharge(
        this.$store.state.https + filePath,
        fileName
      )
    },
    // 查看
    onSee (attachment) {
      this.$refs.brandDialogRef.onBlackDialog(attachment)
    },
    onModifyCancel () {
      this.isModify = false
    },
    // 请求银行账户
    bankList () {
      queryBySuId(this.params.subId)
        .then((res) => {
          if (res.data.code === 200) {
            this.contractScreenCondition = res.data.obj
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取数据
    getList () {
      queryRechargeDetailById(this.$route.query.sraId)
        .then((res) => {
          if (res.data.code === 200) {
            this.params = res.data.obj
            console.log(this.params)
            this.bankList()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 银行回调
    addAccountDialog () {
      this.bankList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 修改
    onModify () {
      this.isModify = true
    },
    // 提交
    onSubmit () {
      this.isModify = false
      const params = {
        receiptBankNumber: this.params.receiptBankNumber,
        receiptOpenNumber: this.params.receiptOpenNumber,
        receiptOpenBank: this.params.receiptOpenBank,
        receiptName: this.params.receiptName,
        id: +this.$route.query.sraId
      }

      updateSupplierRecharge(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('修改成功')
            this.$router.push({
              name: 'SupplierRechargeRecord'
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 银行账户change
    changeBank () {
      this.contractScreenCondition.forEach((element) => {
        if (element.bankCode === this.params.receiptBankNumber) {
          this.params.receiptOpenBank = element.bankOpenCode
          this.params.receiptOpenNumber = element.bankOpencount
        }
      })
    },
    // 添加账户
    onAddAccount () {
      const paramsList = {
        suName: this.params.suName,
        suId: this.params.subId
      }
      this.$refs.addBankAccountDialogRefs.onInitial(paramsList)
    }
  },
  filters: {
    dateFilter, dateFilterDate
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
function dateFilterDate (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd')
  }
}
</script>
<style  scoped>
.item-box-content {
  padding-bottom: 0 !important;
}
.grayApply {
  background-color: #f5f7fa;
  padding-top: 18px;
  padding-left: 15px;
  padding-bottom: -15px !important;
  border-radius: 4px;
}
.padding {
  padding: 20px 30px 0 30px;
}
.paddingBottom {
  padding: 20px 30px 20px 30px;
}
.deepRed {
  background-color: #ffeeee;
  padding: 20px 20px 0 20px;
}
</style>
